module.exports = __webpack_public_path__ + "static/media/ExitFullScreen.e1cf4a0a.svg";